const SHOWNAVPOINT = 'SHOWNAVPOINT';
const HIDENAVPOINT = 'HIDENAVPOINT';
const HIDEALLNAVPOINT = 'HIDEALLNAVPOINT';


export default {
    SHOWNAVPOINT,
    HIDENAVPOINT,
    HIDEALLNAVPOINT,
};